import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import MaterialTable, { MTableCell } from 'material-table';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core';
import useWindowDimensions from '../../../../../features/events-and-classes/utils/useWindowDimensions';
import { fetchDeliveryEventsData, mapDeliveryRows } from '../api';
import { toast } from '../../../../../redux/actions/UI';
import { Container } from './DeliveryActivityTable.styled';

const columns = [
  {
    field: 'contact',
    title: 'Contact',
    width: '65%',
    defaultSort: 'asc',
  },
  {
    field: 'deliveryDate',
    title: 'Delivery Date',
    width: '30%',
  },
];

const DeliveryActivityTable = ({
  messageId,
  rows,
  setRows,
  isLoading,
  setLoading,
  orgId,
  channel,
}) => {
  const { height } = useWindowDimensions();
  const dispatch = useDispatch();

  const theme = createMuiTheme({
    palette: {
      secondary: {
        main: '#1890FF',
      },
    },
  });

  useEffect(() => {
    fetchEvents();
  }, [messageId, channel]);

  const fetchEvents = async () => {
    try {
      setLoading(true);

      const data = await fetchDeliveryEventsData({
        messageId,
        orgId,
        channel,
      });
      const tableRows = mapDeliveryRows(data?.deliveryTableData);

      setLoading(false);
      setRows(tableRows);
    } catch (e) {
      console.error(e);
      dispatch(toast('error', 'Failed to fetch delivery events data'));
    }
  };

  const getEmptyMessage = () => {
    return isLoading ? (
      <>No records to display</>
    ) : (
      <>No delivery events found for this message.</>
    );
  };

  return (
    <Container>
      <MuiThemeProvider theme={theme}>
        <MaterialTable
          isLoading={isLoading}
          components={{
            Cell: props => <MTableCell {...props} />,
          }}
          columns={columns}
          data={isLoading ? [] : rows}
          options={{
            showTitle: false,
            search: false,
            pageSize: Math.round((height - 300) / 48),
            toolbar: false,
            headerStyle: {
              fontWeight: 'bold',
            },
            pageSizeOptions: [],
            tableLayout: 'fixed',
            rowStyle: rowData => ({
              backgroundColor: rowData.wasDelivered ? '#FFF' : '#f8d7da',
            }),
          }}
          localization={{
            body: {
              emptyDataSourceMessage: getEmptyMessage(),
            },
          }}
        />
      </MuiThemeProvider>
    </Container>
  );
};

export default DeliveryActivityTable;
